import { CLIENT } from '../parameters';

import api from '../services/Api';
import GoogleTagManager from '../services/GoogleTagManager';

import { networkErrorAction } from '../actions/UiActions';
import {
	contactDuplicityCheckAction,
	contactDuplicityDoneAction,
	submittedRegistrationAction,
	submittedRegistrationErrorAction,
	submittingRegistrationAction,
	setRegistrationData
} from '../actions/RegistrationFormActions';
import { setPaymentConfig } from '../actions/AdyenPaymantActions';

// {headers: {'Content-Type': 'multipart/form-data'}}
class RegistrationRepository {

	static fieldTranslations = {
		firstName: 'First name',
		lastName: 'Last name',
		birthday: 'Birth date',
		email: 'E-mail',
		phone: 'Mobile phone number',
		'deliveryAddress.country': 'Country',
		'deliveryAddress.postalCode': 'Postal code',
		'deliveryAddress.city': 'City',
		'deliveryAddress.street': 'Street name',
		'deliveryAddress.houseNumber': 'House number',
		'deliveryAddress.additional': 'Additional (company reception, etc...)'
	};

	/**
	 * Check if the email and phone are already used in registration form.
	 *
	 * @param {string} raffleId
	 * @param {string} email
	 * @param {string} phone
	 * @param {string|null} registrationId
	 * @return {function(*=): (PromiseLike<T> | Promise<T> | *)}
	 */
	checkContactDuplicity = (raffleId, email, phone, registrationId) => (dispatch) => {
		dispatch(contactDuplicityCheckAction());
		return api.post('/registrations/check-duplicity/' + raffleId, { email, phone, id: registrationId }).then(res => {
			dispatch(contactDuplicityDoneAction(res.data));
		}).catch(error => {
			dispatch(networkErrorAction(error));
		});
	};

	/**
	 * @return {function(*=): (PromiseLike<T> | Promise<T> | *)}
	 */
	submitReservation = (raffle, reservationData, deliveryService) => (dispatch) => {
		dispatch(submittingRegistrationAction());

		return api.post('/registrations/create/' + raffle.id, reservationData).then(res => {
			const { registration, details } = res.data;

			GoogleTagManager.logTransaction(raffle, reservationData, registration, deliveryService);

			dispatch(submittedRegistrationAction(registration));

			dispatch(setPaymentConfig(details));
		}).catch((error) => {
			if (CLIENT) {
				window.scrollTo(0, 0);
			}

			if (error.response) {
				if (error.response.data && error.response.data.data) {
					dispatch(setRegistrationData(error.response.data.data));
				}

				if (error.response.status === 422) {
					dispatch(submittedRegistrationErrorAction(this.formatErrors(error.response.data.error, error.response.data.errors)));
				}
			}
			else {
				dispatch(networkErrorAction(error));
			}
		});
	};

	formatErrors = (error, errors) => {
		const result = [];

		if (error) {
			result.push(error);
		}

		for (let field in errors) {
			if (errors.hasOwnProperty(field)) {
				const mistakes = [];
				const messages = errors[field];
				for (let validatorId in messages) {
					if (messages.hasOwnProperty(validatorId)) {
						mistakes.push(messages[validatorId]);
					}
				}
				result.push(this.translateField(field) + ': ' + mistakes.join(', '));
			}
		}

		return result;
	};

	translateField = (field) => {
		if (RegistrationRepository.fieldTranslations.hasOwnProperty(field)) {
			return RegistrationRepository.fieldTranslations[field];
		}
		return field;

	};
}

export default new RegistrationRepository();



// WEBPACK FOOTER //
// ./repositories/RegistrationRepository.js